var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"financial-institution-selector"},[_c('el-select',{staticClass:"mb-4",attrs:{"value":_vm.value,"placeholder":"เลือกสถาบันการเงิน"},on:{"input":_vm.handleChange}},_vm._l((_vm.financialInstitutions),function(f){return _c('el-option',{key:f.id,attrs:{"label":f.name,"value":f.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }